'use client';
import React from 'react';

export default function Footer() {
  const currentYear = 2025;

  return (
    <footer
      style={{
        backgroundColor: '#414141',
        color: '#fff',
        padding: '20px',
      }}
    >
      <div
        style={{
          maxWidth: '1140px',
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'space-between',
          alignItems: 'center',
          gap: '12px',
        }}
      >
        <p
          style={{
            fontFamily: 'Lato, sans-serif',
            fontSize: '14px',
            color: '#fff',
            margin: 0,
          }}
        >
          Copyright &copy; {currentYear} GOTTSCHO PRINTING SYSTEMS, Inc. &middot; All Rights Reserved
        </p>
        <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
          <a
            href="#contact"
            style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '13px',
              color: '#ccc',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            className="footer-link"
          >
            Contact
          </a>
          <a
            href="#services"
            style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '13px',
              color: '#ccc',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            className="footer-link"
          >
            Services
          </a>
          <a
            href="tel:3216634402"
            style={{
              fontFamily: 'Lato, sans-serif',
              fontSize: '13px',
              color: '#ccc',
              textDecoration: 'none',
              transition: 'color 0.2s',
            }}
            className="footer-link"
          >
            (321) 663-4402
          </a>
        </div>
      </div>
      <style jsx>{`
        .footer-link:hover { color: #f89921 !important; }
      `}</style>
    </footer>
  );
}
